var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.5 124.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 102.1c10.5 0 20.2-3.2 28.3-8.6l29.3 29.3c2.3 2.3 6.1 2.3 8.5 0l5.7-5.7c2.3-2.3 2.3-6.1 0-8.5L93.4 79.3c5.4-8.1 8.6-17.8 8.6-28.3 0-28.1-22.9-51-51-51S0 22.9 0 51s22.8 51.1 51 51.1zM51 20c17.1 0 31 13.9 31 31S68.1 82 51 82 20 68.1 20 51s13.9-31 31-31z",
    fill: "#c5c5c5"
  })));
}

export default __webpack_public_path__ + "1e2512f09d5ee758a5e0dad2488c1199.svg";
export { SvgSearch as ReactComponent };